import type { IconProps } from './schemas';

export function ChipIcon({
  className = 'h-4 w-4 self-center inline-block',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="currentColor"
      className={className}
    >
      <g>
        <path d="M10.0573 11.9751C12.1406 11.9751 13.8355 10.2803 13.8355 8.1971C13.8355 6.1139 12.1406 4.41895 10.0573 4.41895C7.97399 4.41895 6.2793 6.11377 6.2793 8.1971C6.2793 10.2804 7.97412 11.9751 10.0573 11.9751Z" />
        <path d="M20.19 12.7644V7.56445H14.5547C14.4856 8.41672 14.1792 10.2028 13.7012 10.8561L15.7152 12.7644H20.19Z" />
        <path d="M6.48221 5.44767L4.61721 3.7666H0V8.00049H5.56077C5.63305 7.10844 5.96519 6.11829 6.48221 5.44767Z" />
        <path d="M4.57594 12.7654L6.48761 10.9541C5.96762 10.2821 5.63332 8.89599 5.56077 8.00098H0V12.7654H4.57594Z" />
        <path d="M10.4258 3.69981C11.5124 3.78786 12.4913 4.2616 13.2248 4.98481L15.392 3.03121H20.1906V2.20537C20.1906 0.992378 19.1982 0 17.9852 0H10.4258V3.69981Z" />
        <path d="M9.69008 12.6936C8.64807 12.6092 7.70532 12.1698 6.98292 11.4961L4.86884 13.4993H0V14.3351C0 15.5481 0.992378 16.5405 2.20537 16.5405H9.69008V12.6936Z" />
        <path d="M15.6749 3.7666L13.7051 5.54207C14.1815 6.19462 14.4867 6.97905 14.5557 7.82957H20.1911V3.7666H15.675H15.6749Z" />
        <path d="M15.4229 13.4998L13.2206 11.4131C12.4877 12.1339 11.5103 12.6061 10.4258 12.694V16.541H17.9852C19.1982 16.541 20.1906 15.5486 20.1906 14.3356V13.4998H15.4229Z" />
        <path d="M4.89972 3.03121L6.97658 4.90336C7.69979 4.22627 8.64511 3.78463 9.69008 3.69981V0H2.20537C0.992378 0 0 0.992378 0 2.20537V3.03121H4.89972Z" />
      </g>
    </svg>
  );
}
